<template>
  <v-layout column>
    <vbt-search
      v-model="searchData"
      :items="searchFieldsConfig"
      @reset="onResetSearch"
      @search="onSearch"
    />

    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      :no-content="noContent"
      :go-back-btn="goBack"
      title="Information"
    >
      <vbt-table
        :items="pressSheets"
        :headers="headers"
        show-details-action
        @click:details="({ outerId: id }) => $router.push({
          name: 'pressSheet',
          params: { id },
          query: { suffix },
        })"
      >
        <template #id="{ item: { outerId: id } }">
          <router-link
            :to="{
              name: 'pressSheet',
              params: { id },
              query: { suffix },
            }"
            class="info--text"
          >
            {{ id }}
          </router-link>
        </template>
        <template #status="{ item: { status } }">
          <kernel-status-badge :status="pressSheetStatusEnumByValue[status]">
            {{ status }}
          </kernel-status-badge>
        </template>
        <template #uv="{ item: { uvFront, uvBack } }">
          <v-layout column>
            <v-layout v-show="uvFront">
              Front: {{ uvFront }}
            </v-layout>
            <v-layout v-show="uvBack">
              Back: {{ uvBack }}
            </v-layout>
          </v-layout>
        </template>
        <template #expires="{ item: { expires } }">
          {{ formatDate(expires) }}
        </template>
      </vbt-table>

      <vbt-pagination
        v-model="pageNum"
        :items-count="pagedItemsCount"
      />
    </vbt-content-box>
  </v-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import { useDataLoading, usePagination, useSearch } from '@mixins/factories';
import { formatDate } from '@helpers';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import {
  namespace as PressSheetsNamespace,
  ActionTypes as PressSheetsActionTypes,
} from '../store.types';

const dataLoadingOptions = {
  getterName: PressSheetsActionTypes.GET_PRESS_SHEETS,
  contentName: 'pressSheets',
};
const paginationOptions = {
  contentName: 'pressSheets',
};
const searchOptions = {
  initialSearchDataStates: [
    'state', 'outerId',
  ],
};

const headers = Object.freeze([
  { text: 'ID', value: 'id' },
  { text: 'Machine', value: 'machine' },
  { text: 'Substrate', value: 'substrate' },
  { text: 'Status', value: 'status' },
  { text: 'Priority', value: 'priority' },
  { text: 'Quantity', value: 'quantity' },
  { text: 'Sides', value: 'sides' },
  { text: 'UV', value: 'uv' },
  { text: 'Expires Date', value: 'expires' },
]);

export default {
  name: 'KernelPressSheets',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(PressSheetsNamespace, ['pressSheets']),
    ...mapState(LocationsNamespace, ['suffix']),
    ...mapState(EnumsNamespace, {
      pressSheetActivityStatuses: ({ enums: { pressSheetStatus: enums } }) => (enums || [])
        .map(({ value }) => value),
    }),
    ...mapGetters(EnumsNamespace, ['pressSheetStatusEnumByValue']),
    searchFieldsConfig() {
      return [
        { value: 'outerId', label: 'Outer ID', type: 'text' },
        {
          value: 'state',
          items: this.pressSheetActivityStatuses,
          label: 'State',
          type: 'select',
        },
      ];
    },
  },
  watch: {
    suffix: '$_refreshData',
  },
  methods: {
    ...mapActions(PressSheetsNamespace, [PressSheetsActionTypes.GET_PRESS_SHEETS]),
    formatDate,
  },
};
</script>
